import { appStudentUrl, graphQlUrl } from '@/constants/config'

// The admin credential stays in this origin. Only a scoped 5-minute grant crosses the window boundary.
export function openStudentSupport (vm, target) {
  let child
  let timer
  let busy = false
  let sent = false
  let stopped = false
  const nonceBytes = new Uint8Array(16)
  window.crypto.getRandomValues(nonceBytes)
  const nonce = Array.from(nonceBytes).map(n => n.toString(16).padStart(2, '0')).join('')
  const cleanup = () => {
    stopped = true
    window.removeEventListener('message', receive)
    window.clearTimeout(timer)
  }
  const fail = () => {
    cleanup()
    if (child && !child.closed) child.close()
    vm.$vs.dialog({ color: 'warning', title: 'เปิดโหมดผู้ดูแลไม่ได้', text: 'กรุณาตรวจสิทธิ์ผู้ใช้งาน การอนุญาตป๊อปอัป และการตั้งค่า URL ของระบบ แล้วลองใหม่', acceptText: 'ตกลง' })
  }
  let destination
  try {
    if (!appStudentUrl) throw new Error('missing_url')
    destination = new URL(`${appStudentUrl.replace(/\/$/, '')}/student-support`)
    if (!['https:', 'http:'].includes(destination.protocol)) throw new Error('invalid_url')
    if (process.env.NODE_ENV === 'production' && destination.protocol !== 'https:') throw new Error('https_required')
  } catch (error) { fail(); return }
  async function receive (event) {
    if (stopped || event.origin !== destination.origin || event.source !== child || !event.data || event.data.nonce !== nonce) return
    if (event.data.type === 'wel-support-accepted' && sent) { cleanup(); return }
    if (event.data.type !== 'wel-support-ready' || busy) return
    busy = true
    try {
      const response = await fetch(graphQlUrl, {
        method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', authorization: localStorage.getItem('token') || '' },
        body: JSON.stringify({ query: 'mutation IssueStudentSupport($studentId: String, $contractId: String) { issueStudentSupportView(studentId: $studentId, contractId: $contractId) { token expiresAt contractId } }', variables: target })
      })
      const payload = await response.json()
      const grant = payload.data && payload.data.issueStudentSupportView
      if (!response.ok || payload.errors || !grant || typeof grant.token !== 'string') throw new Error('denied')
      if (stopped || child.closed) return
      sent = true
      child.postMessage({ type: 'wel-support-grant', nonce, token: grant.token, expiresAt: grant.expiresAt, contractId: grant.contractId }, destination.origin)
    } catch (error) { if (!stopped) fail() }
  }
  window.addEventListener('message', receive)
  child = window.open(`${destination.href}#nonce=${nonce}`, '_blank')
  if (!child) { fail(); return }
  timer = window.setTimeout(fail, 45000)
}
